import { ref } from 'vue'

// 访客从哪个方案点进联系表单，随表单一起发到飞书，方便判断客户意向
export const leadIntent = ref('')
export function setIntent(name) { leadIntent.value = name || '' }
